export type LogLevel = 'log' | 'warn' | 'error' | 'debug';

                                                                      
export interface LogRecord {
  time: number;
  level: LogLevel;
                                                                      
  package: string;
                                   
  scope: string;
  message: string;
  meta?: unknown;
}

export type LogSink = (record: LogRecord) => void;

interface SinkRegistry {
  sinks: Set<LogSink>;
  emitting: boolean;
}

   
                                                                  
  
                                                                             
                                                                                
                                                                                
                                                                         
                            
   
const REGISTRY_KEY = '__syncVideoLogSinks__';

function registry(): SinkRegistry {
  const holder = globalThis as typeof globalThis & {
    [REGISTRY_KEY]?: SinkRegistry;
  };
  const existing = holder[REGISTRY_KEY];
  if (existing) {
    return existing;
  }
  const created: SinkRegistry = { sinks: new Set(), emitting: false };
  holder[REGISTRY_KEY] = created;
  return created;
}

                                                                        
export function onLogRecord(sink: LogSink): () => void {
  const { sinks } = registry();
  sinks.add(sink);
  return () => {
    sinks.delete(sink);
  };
}

                                                                                 
export function hasLogSinks(): boolean {
  return registry().sinks.size > 0;
}

   
                                 
  
                                                                               
                                                                                
                                                                        
                                                                              
                                                                             
   
export function suppressLogRecords<T>(fn: () => T): T {
  const state = registry();
  const previous = state.emitting;
  state.emitting = true;
  try {
    return fn();
  } finally {
    state.emitting = previous;
  }
}

   
                               
  
                                                                               
                                                                          
                                                                              
                                                          
   
export function emitLogRecord(record: LogRecord): void {
  const state = registry();
  if (state.emitting || state.sinks.size === 0) {
    return;
  }
  state.emitting = true;
  try {
    for (const sink of state.sinks) {
      try {
        sink(record);
      } catch {
                                       
      }
    }
  } finally {
    state.emitting = false;
  }
}
